import { AppLayout } from 'layouts';
import { ChatCreate, ChatCreateLayout } from 'features/chat';
import {
  useChatroomsSearchParams,
  useCreateChatUserFromLocation,
  useNavigateToChat,
  useNavigateToChatroom,
  useNavigateToCreateChat,
} from '../hooks';

const PageCreateChat = () => {
  const navigateToChat = useNavigateToChat();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();
  const navigateToChatroom = useNavigateToChatroom();
  const { userToChat } = useCreateChatUserFromLocation();

  return (
    <AppLayout fitCenterContent>
      <ChatCreateLayout
        onChatDeleted={navigateToChat}
        onChatRoomClicked={navigateToChatroom}
        onCreateChatClicked={navigateToCreateChat}
        searchParamsOptions={searchParamsOptions}
      >
        <ChatCreate
          key={userToChat?.id}
          onClose={navigateToChat}
          onCreated={async (chatroomId, pendingMessage) => navigateToChatroom(chatroomId, { pendingMessage })}
          userToChat={userToChat}
        />
      </ChatCreateLayout>
    </AppLayout>
  );
};

export default PageCreateChat;
